<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',

  created() {
    const res = window.TTMinis.getDeviceInfo()
    this.$store.commit("common/setDeviceInfo", res || {})
  },
}
</script>

<style lang="less">
@import "./assets/css/reset.css";

body {
  background: #050505;
}

#app {
  height: 100%;
}
</style>
